import { type ProductData } from "~/models/ProductData";
import Modal from "~/common/components/Modal";
import { HousingTabularViewDetailPanel } from "~/HousingSelectionAssistant/components/VariantProductsTableModal/HousingTabularViewDetailPanel";
import classes from "./VariantProductsTableModal.module.less";

interface Props {
  onClose: () => void;
  products: ProductData[];
}

export const VariantProductsTableModal = (props: Props) => {
  return (
    <Modal onClose={props.onClose} modalClassName={classes.modal} modalBgClassName={classes.modalRoot}>
      <HousingTabularViewDetailPanel products={props.products} />
    </Modal>
  );
};
